export default __webpack_public_path__ + "static/media/Decrement2.43c0860d.svg";